import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const recruiterLoginRegister = {
    mobile: {
        header: {
            background: Color.DeepBlack,
            marginTop: "0%",
            marginLeft: "0%",
            width: "100%",
            height: "29.46vw",
            position: "relative",
            line: {
                height: "1px",
                borderWidth: 0,
                color: Color.LightBlue,
                backgroundColor: Color.LightBlue,
                margin: 0,
                position: 'relative',
                zIndex: "2"
            },
            backButton: {            
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.White,
                boxShadow: "0px 0px 0px 1.45vw rgb(255 255 255 / 0.35)",
                borderRadius: "50%",       
                margin: "9.66vw 0 0 6.28vw",     
                icon: {
                    fill: Color.MiddleBlack,
                    width: "2.90vw"
                }
            },
            backgroundSvg: {
                position: "absolute" as "absolute",
                right: "0",
                bottom: "0",
                width: "61.3vw",
                height: "34.3vw",
                zIndex: "0",
                lostPassword: {
                    width: "90.84vw",
                    height: "51.68vw"
                }
            },
            lostPassword: {
                height: "66.73vw"
            }
        },
        startCurve: {
            display: "none",
            position: "absolute",
            top: "-9.8vw",
            width: "89vw",
            height: "34vw",
            zIndex: "0",
            pointerEvents: "none" 
        },
        endCurve: {
            display: "none",
            position: "absolute",
            top: "-4.5vw",
            width: " 98vw",
            height: "33vw",
            zIndex: "0",
            pointerEvents: "none"
        },
        mainWrapper: {
            display: "flex"            
        },
        recruitersSvg: {
            display: "none"
        },
        loginForm: {
            width: "90.34vw",
            backgroundColor: Color.White,
            padding: "0 4.83vw",
            marginTop: "14.49vw",
            zIndex: "1"
        },
        registerForm: {
            width: "90.34vw",
            backgroundColor: Color.White,
            padding: "0 4.83vw",
            marginTop: "14.49vw",
            zIndex: "1"
        },
        loginPassword: {
            marginTop: "3.62vw"
        },
        callbackMessage: {
            height: "auto",
            padding: "4.83vw 3.38vw",
            margin: "3.24vh 0 0 0",
            borderRadius: "2.41vw",
            border: "0.24vw solid " + Color.HarvestGold,
            backgroundColor: Color.LightGold,
            fontFamily: Font.Poppins,
            fontSize: "3.86vw",
            fontWeight: 500,
            color: Color.HarvestGold,
            textAlign: "center"
        },
        passwordForm: {
            width: "90.34vw",
            backgroundColor: Color.White, 
            padding: "0 4.83vw",
            zIndex: "1",
            reset: {
                margin: "24.15vw 0 18.69vw"
            },
            lost: {
                margin: "24.15vw 0 9.69vw"
            }
        },
        accordionButtonsContainer: {
            borderBottom: "2px solid " + Color.DeepBlack,
            display: "flex",
            justifyContent: "center"
        },
        accordionButton: {
            height: "9.42vw",
            borderTop: "2px solid " + Color.DarkAsh,
            borderBottom: "none",
            fontFamily: Font.Default,
            fontWeight: "bold",
            fontSize: "4.83vw",
            backgroundColor: Color.White,
            color: Color.SharpAsh,
            textAlign: "center" as "center",
            cursor: "pointer",
            letterSpacing: "0",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            WebkitTapHighlightColor : "transparent",
            left: {
                width: "22vw",
                borderRadius: "5px 0px 0px 0px",
                borderLeft: "2px solid " + Color.DarkAsh,
                borderRight: "none"
            },
            right: {
                width: "29vw",
                borderRadius: "0px 5px 0px 0px",
                borderLeft: "none",
                borderRight: "2px solid " + Color.DarkAsh
            },
            selected: {
                border: "2px solid " + Color.DeepBlack,
                color: Color.White,
                backgroundColor: Color.DeepBlack,
                fontWeight: "500"
            }
        },
        title: {
            color: Color.LightBlack,
            fontSize: "6.03vw",
            margin: "0 0 0 3.86vw"            
        },
        subTitle: {
            color: Color.SharpAsh,
            fontSize: "4.83vw",
            fontWeight: "bold" as "bold",
            margin: "6.03vw 0 6.03vw 3.86vw"
        },
        boldTitle: {
            color: Color.DeepBlack,
            fontSize: "4.83vw",
            fontWeight: "bold",
            margin: "7.25vw 0 6.04vw 3.62vw"
        },
        hyperLink: {
            color: Color.DeepBlack,
            fontWeight: "bold",
            cursor: "pointer",
            marginLeft: "2.90vw",
            WebkitTapHighlightColor : "transparent"
        },
        normalText: {
            margin: "4.83vw 0 6.28vw 0",
            fontSize: "3.86vw",
            fontWeight: 500,
            color: Color.SharpAsh
        },
        row: {
            display: "block",
            password: {
                width: "100%"
            }
        },
        resetNow: {
            border: "2px solid " + Color.Blue,
            color: Color.Blue,
            marginLeft: "2%",
            cursor: "pointer",
            textTransform: "uppercase",
            borderRadius: "1.2vw",
            fontFamily: Font.Default,
            fontWeight: "bold" as "bold",
            fontSize: "2.89vw",
            background: "transparent",
            WebkitTapHighlightColor: "transparent",
            width: "30.19vw",
            height: "6.04vw"
        },
        registerNowWrapper: {
            padding: "1.67vh 0 3.348vh 0",
            textAlign: "center" as "center",
            color: Color.SharpAsh,
            fontSize: "3.86vw"
        },
        loginNowSection: {
            textAlign: "center" as "center"
        },
        loginNowWrapper: {
            fontSize: "3.86vw",            
            color: Color.SharpAsh,
            margin: "3.62vw 0 7.25vw 0"
        },
        submitButton: {
            border: "none",
            backgroundColor: Color.Green,
            color: Color.White,
            width: "100%",
            height: "12.08vw",
            borderRadius: "2.41vw",
            fontSize: "4.34vw",
            fontFamily: Font.Default,
            fontWeight: "bold" as "bold",
            textTransform: "uppercase",
            boxShadow: "5px 5px 50px #00000027",
            cursor: "pointer"
        },
        organizationLogoUpload: {
            marginTop: "3.62vw"
        },
        registerLeftInput:{
            marginTop: "3.62vw"
        },
        registerRightInput:{
            marginTop: "3.62vw"
        },
        fileWarning: {
            fontSize: "2.65vw",
            color: Color.SharpAsh,
            margin: "2.41vw 0 0 0",
            bold: {
                fontWeight: "500"
            }
        },
        sharpText: {
            fontSize: "3.14vw",            
            color: Color.SharpAsh,
            margin: "2%",
            black: {                
                fontWeight: "500",
                color: Color.DeepBlack,
                cursor: "pointer",
                textDecoration: "none"
            },
            bold: {                
                fontWeight: "bold",
                color: Color.DeepBlack,
                cursor: "pointer"
            }
        },
        policyWrapper: {
            fontSize: "3.62vw",
            color: Color.SharpAsh,
            marginTop: "6.04vw"
        },
        policyLabel: {
            marginLeft: "1.21vw"
        },
        registerWrapper: {
            width: "100%",
            margin: "9.66vw 0 0 0",
            textAlign: "center" as "center"
        },
        resetButton: {
            marginTop: "8.45vw"
        },
        invalidDialog: {
            container: {
                width: "calc(100% - 9.66vw)",
                height: "25.83vw",
                padding: "7.246vw 4.93vw",
                borderRadius: "2.415vw 2.415vw 0 0",
                fontWeight: "bold",
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center" 
            }
        }
    },
    desktop: {
        header: {
            height: "37.98vw",
            marginBottom: "-6vw",
            line: {
                height: "2px"
            },
            backButton: { 
                display: "none"
            },
            backgroundSvg: {
                width: "100%",
                height: "16.145vw"
            },
            messgeEnabledLogin: {
                height: "43vw"
            },
            messageEnabledRegister: {
                height: "48.41vw"
            },
            register: {
                height: "45.41vw"
            },
            lostPassword: {
                height: "37.98vw" 
            }
        },
        startCurve: {
            display: "block",
            top: "-7.45vw"
        },
        endCurve: {
            display: "block",
            top: "1.55vw"
        },
        mainWrapper: {
            marginBottom: "-1.83vw"
        },
        recruitersSvg: {
            display: "flex",
            height: "26.58vw",
            width: "42.38vw",
            backgroundSize: "42.38vw 26.58vw",
            backgroundImage: "url(" + process.env.PUBLIC_URL + "/img/candidates.svg)",
            backgroundRepeat: "no-repeat",            
            backgroundPosition: "left",            
            marginTop: "6.51vw",
            marginLeft: "9.01vw",
            transition: "all 0.2s ease-in-out",
            position: "relative" as "relative",
            register: {
                height: "26.58vw",
                width: "34.38vw",
                backgroundSize: "34.38vw 26.58vw",
                marginLeft: "4.6vw",
                zIndex: "2"
            },
            zIndex: 2
        },
        accordionButtonsContainer: {
            borderBottom: "0.15vw solid " + Color.DeepBlack
        },
        loginForm: {
            position: "absolute" as "absolute",
            width: "29.89vw",
            right: "7.29vw",
            top: "12.71vw",
            borderRadius: "0.52vw",
            border: `2px solid ${Color.LightAsh}`,
            padding: "2.08vw 2.60vw",
            marginTop: 0
        },
        registerForm: {
            position: "absolute" as "absolute",
            width: "42.5vw",
            right: "7.29vw",
            top: "12.71vw",
            borderRadius: "0.52vw",
            border: `2px solid ${Color.LightAsh}`,
            padding: "2.08vw 2.6vw",
            marginTop: 0,
            messageEnabled: {
                top: "12.71vw"
            }
        },
        loginPassword: {
            marginTop: "0.78vw"
        },
        passwordForm: {
            position: "absolute" as "absolute",
            right: "7.65%",
            borderRadius: "0.52vw",
            border: `2px solid ${Color.LightAsh}`,
            padding: "2.6vw",
            margin: 0,
            reset: {
                width: "29.78vw",
                height: "19.90vw",
                top: "29.91%",
                margin: "unset"
            },
            lost: {
                width: "29.75vw",
                height: "15.75vw",
                top: "15.53vw",
                margin: "unset"
            }
        },
        registerLeftInput: {
            marginLeft: "0.83vw",
            marginTop: "0.78vw"
        },
        registerRightInput: {
            marginTop: "0.78vw"
        },
        callbackMessage: {
            padding: "0.5vw 4.40vw",
            margin: "2.68vh 0 0 0",
            borderRadius: "0.52vw",
            border: "0.05vw solid " + Color.HarvestGold,
            fontSize: "0.94vw"
        },
        accordionButton: {
            height: "2.96vw",
            fontSize: "1.3vw",
            fontWeight: "500",
            left: {
                width: "7.29vw",
                borderRadius: "0.52vw 0px 0px 0px"
            },
            right: {
                width: "9.42vw",
                borderRadius: "0px 0.52vw 0px 0px"
            },
            selected: {
                fontSize: "1.56vw",
                fontWeight: "bold"
            }
        },        
        title: {
            fontSize: "1.56vw",
            marginLeft: "0.5vw"
        },
        subTitle: {
            fontSize: "1vw",
            margin: "1.41vw 0 0.78vw 0.5vw"
        },
        boldTitle: {            
            fontSize: "0.94vw",            
            margin: "1.56vw 0 0.78vw 0.52vw",
            register: {
                margin: "1.56vw 0 0 0.52vw"
            }
        },
        hyperLink: {
            marginLeft: "0.83vw"            
        },
        normalText: {
            fontSize: "0.93vw",
            margin: "0.78vw 0 1.56vw 0.52vw",
            color: Color.DeepBlack
        },
        row: {
            display: "flex"
        },
        registerWrapper: {
            width: "46%",
            margin: "1.56vw 0 0 0"
        },
        resetButton: {
            marginTop: "1.56vw"
        },
        resetNow: {
            border: "3px solid " + Color.Blue,
            width: "10.15vw",
            height: "1.82vw",
            fontSize: "0.78vw",
            borderRadius: "0.26vw"            
        },
        submitButton: {
            height: "3.64vw",
            borderRadius: "0.52vw",
            fontSize: "1.04vw"        
        },
        organizationLogoUpload: {
            cursor: "pointer",
            marginLeft: "0.83vw",
            marginTop: "0.65vw"
        },
        fileWarning: {
            fontSize: "0.83vw",            
            margin: "0.52vw 0 0 22.32vw"
        },
        sharpText: {
            fontSize: "0.83vw",
            marginTop: "2.77vh"
        },
        policyWrapper: {
            display: "flex",
            fontSize: "0.93vw",            
            margin: "1.56vw 0 0 0.52vw"
        },
        policyLabel: {
            marginLeft: "0.52vw"
        },
        policyLabelError:{
            color : "red"
        },
        registerButton: {
            width: "19.53vw",
            float: "left"
        },
        registerNowWrapper: {
            fontSize: "0.93vw",
            padding: "1.30vw 0 0 0",
            color: Color.SharpAsh
        },
        loginNowSection: {
            margin: "1.30vw 0 0 1.30vw"
        },
        loginNowWrapper: {
            fontSize: "0.93vw",            
            margin: "1.30vw 0 0 0"
        },
        logoGride: {
            marginTop: "6.38vw",
            logo: {
                width: "3.80vw",
                height: "3.85vw",
                borderRadius: "0.52vw",
                marginRight: "3.75vw"
            },
            loaderContainer: {
                marginTop: "8.54vw"
            },
            loaderBox: {
                marginTop: "unset",
                width: "3.8vw",
                height: "3.8vw"
            }
        },
        invalidDialog: {
            container: {
                width: "25.33vw",
                height: "1.76vw",
                padding: "3.489vw 3.54vw",
                borderRadius: "0.52vw",
                fontSize: "1.1vw"
            }
        }
    }
}
